export default function productsAdditionalInfo(state = {}, action) {
  if (action.type === 'SET_ADDITIONAL_INFO') {
    if (Array.isArray(state.metaElementData) && state.metaElementData.length > 0) {
      action.values.metaElementData = state.metaElementData;
    }
    const { values = {} } = action;
    const newPriceReveal = values.priceRevealMetaInfo;
    if (
      state.priceRevealMetaInfo?.saleStartTime &&
      (!newPriceReveal || !newPriceReveal.saleStartTime)
    ) {
      values.priceRevealMetaInfo = state.priceRevealMetaInfo;
    }
    return { ...state, ...values };
  }
  return state;
}
